/**
 * Shared scale maps for the layout primitives (Stack/VStack/HStack/Centre/Grid),
 * mirroring how typography-tones.ts backs Text/Heading. `gap` follows the
 * spacing scale observed across the codebase; `align`/`justify` keep the CSS
 * keyword values.
 */
export type LayoutGap = 0 | 0.5 | 1 | 1.5 | 2 | 2.5 | 3 | 4 | 5 | 6 | 8 | 10;
export type LayoutAlign = 'start' | 'center' | 'end' | 'stretch' | 'baseline';
export type LayoutJustify = 'start' | 'center' | 'end' | 'between' | 'around' | 'evenly';
export type LayoutDirection = 'vertical' | 'horizontal';

export const directionClasses: Record<LayoutDirection, string> = {
  vertical: 'flex-col',
  horizontal: 'flex-row',
};

export const gapClasses: Record<LayoutGap, string> = {
  0: 'gap-0',
  0.5: 'gap-0.5',
  1: 'gap-1',
  1.5: 'gap-1.5',
  2: 'gap-2',
  2.5: 'gap-2.5',
  3: 'gap-3',
  4: 'gap-4',
  5: 'gap-5',
  6: 'gap-6',
  8: 'gap-8',
  10: 'gap-10',
};

export const alignClasses: Record<LayoutAlign, string> = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
  stretch: 'items-stretch',
  baseline: 'items-baseline',
};

export const justifyClasses: Record<LayoutJustify, string> = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
  around: 'justify-around',
  evenly: 'justify-evenly',
};
